import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M8 9h8","key":"svg-0"}],["path",{"d":"M8 13h6","key":"svg-1"}],["path",{"d":"M12 21l-3 -3h-3a3 3 0 0 1 -3 -3v-8a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v5","key":"svg-2"}],["path",{"d":"M16 19a3 3 0 1 0 6 0a3 3 0 1 0 -6 0","key":"svg-3"}],["path",{"d":"M17 21l4 -4","key":"svg-4"}]]

const IconMessage2Cancel = createReactComponent('outline', 'message-2-cancel', 'Message2Cancel', __iconNode);

export default IconMessage2Cancel;